// src/ErrorBoundary.tsx
import React from "react";

type Props = { children: React.ReactNode };
type State = { error: Error | null, info?: React.ErrorInfo | null };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Dump full details to the console so we can see the real cause
    console.error("App crash (ErrorBoundary):", error, info);
    this.setState({ info });
  }

  render() {
    if (!this.state.error) return this.props.children;

    const message = this.state.error?.message || String(this.state.error);
    const stack = this.state.error?.stack || "";
    const componentStack = this.state.info?.componentStack || "";

    return (
      <div style={{ maxWidth: 800, margin: "60px auto", padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <h1 style={{ fontSize: 28 }}>⚠️ Something went wrong</h1>

        <pre style={{ background: "#0e0e0e", color: "#fff", padding: 16, borderRadius: 8, overflow: "auto" }}>
{`Message:
${message}

Stack:
${stack.split("\n").slice(0, 12).join("\n")}

React component stack:
${componentStack}`}
        </pre>

        <button
          onClick={() => location.reload()}
          style={{ padding: "10px 16px", borderRadius: 6, border: "none", cursor: "pointer" }}
        >
          Reload
        </button>
      </div>
    );
  }
}
